module.exports = __webpack_public_path__ + "static/media/16.04121f2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16.jpg
// module id = 191
// module chunks = 0